"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._type = function (x) {
    return Object.prototype.toString.call(x).slice(8, -1);
};
exports._get = function (path, obj, defaultValue) {
    var head = path[0];
    var tail = path.slice(1);
    if (!tail.length) {
        var res = obj[head];
        var isEmpty = (exports._type(res) === 'Object' && Object.keys(res).length === 0) ||
            exports._type(res) === 'Null' ||
            exports._type(res) === 'Undefined';
        return isEmpty ? defaultValue : obj[head];
    }
    return exports._get(tail, obj[head], defaultValue);
};
exports._withMinAndMaxMedia = function (x, y) {
    return "@media (min-width: " + x + ") and (max-width: " + y + ")";
};
exports._makeErrorMessage = function (breakName, breaks) {
    return "'" + breakName + "' is invalid breakpoint name. Use '" + Object.keys(breaks).join(', ') + "'.";
};
exports._makeStyledBreakpoints = function (options) {
    var _options = options || {};
    var state = {
        pathToMediaQueries: _options.pathToMediaQueries || ['breakpoints'],
        errorPrefix: _options.errorPrefix || '[styled-breakpoints]: ',
        defaultMediaQueries: _options.defaultMediaQueries || {
            tablet: '768px',
            desktop: '992px',
            lgDesktop: '1200px',
        },
        browserContext: 16,
        invariant: function (condition, message) {
            if (!condition) {
                throw new Error(state.errorPrefix + message);
            }
        },
        throwInvalidBreakValue: function (breaks) {
            Object.keys(breaks).forEach(function (x) {
                state.invariant(x.indexOf('px') !== -1, "Check your theme. '" + breaks[x] + "' is invalid breakpoint. Use pixels.");
            });
        },
        throwIsInvalidBreakName: function (breakName, breaks) {
            state.invariant(breaks[breakName], exports._makeErrorMessage(breakName, breaks));
        },
        throwIsLastBreak: function (breakName, breaks) {
            var names = Object.keys(breaks);
            var penultimateBreakName = names[names.length - 2];
            var isValid = names.indexOf(breakName) !== names.length - 1;
            state.invariant(isValid, "Don't use '" + breakName + "' because it doesn't have a maximum width. Use '" + penultimateBreakName + "'. See https://github.com/mg901/styled-breakpoints/issues/4 .");
        },
        throwIsInvalidNextBreakValue: function (name, breaks) {
            state.invariant(breaks[name], "'" + name + "' is invalid breakpoint name. Use '" + Object.keys(breaks)
                .slice(0, -1)
                .join(', ') + "'.");
        },
        throwIsInvalidOrientation: function (x) {
            state.invariant(x === 'portrait' || x === 'landscape', "'" + x + "' is invalid orientation. Use 'landscape' or 'portrait'.");
        },
        withOrientationOrNot: function (x, y) {
            if (y) {
                state.throwIsInvalidOrientation(y);
                return x + " and (orientation: " + y + ")";
            }
            return x;
        },
        toEm: function (x) {
            return parseFloat(x) / state.browserContext + "em";
        },
        getBreakpointsFromTheme: function (theme) {
            return exports._get(state.pathToMediaQueries, theme, state.defaultMediaQueries);
        },
        getNextBreakpointName: function (name) {
            return function (breaks) {
                state.throwIsInvalidBreakName(name, breaks);
                state.throwIsLastBreak(name, breaks);
                var names = Object.keys(breaks);
                return names[names.indexOf(name) + 1];
            };
        },
        getNextBreakpointValue: function (name, breaks) {
            state.throwIsInvalidNextBreakValue(name, breaks);
            var getNextName = state.getNextBreakpointName(name);
            return parseFloat(breaks[getNextName(breaks)]) - 0.02 + "px";
        },
        getBreakpointValue: function (name, breaks) {
            state.throwIsInvalidBreakName(name, breaks);
            return breaks[name];
        },
        calcMinWidth: function (name, theme) {
            return state.toEm(state.getBreakpointValue(name, state.getBreakpointsFromTheme(theme)));
        },
        calcMaxWidth: function (name, theme) {
            return state.toEm(state.getNextBreakpointValue(name, state.getBreakpointsFromTheme(theme)));
        },
        up: function (name, orientation) {
            return function (props) {
                return state.withOrientationOrNot("@media (min-width: " + state.calcMinWidth(name, props.theme) + ")", orientation);
            };
        },
        down: function (name, orientation) {
            return function (props) {
                return state.withOrientationOrNot("@media (max-width: " + state.calcMaxWidth(name, props.theme) + ")", orientation);
            };
        },
        between: function (min, max, orientation) {
            return function (props) {
                return state.withOrientationOrNot(exports._withMinAndMaxMedia(state.calcMinWidth(min, props.theme), state.calcMaxWidth(max, props.theme)), orientation);
            };
        },
        only: function (name, orientation) {
            return function (props) {
                return state.withOrientationOrNot(exports._withMinAndMaxMedia(state.calcMinWidth(name, props.theme), state.calcMaxWidth(name, props.theme)), orientation);
            };
        },
    };
    return state;
};
var bp = exports._makeStyledBreakpoints();
exports.up = bp.up;
exports.down = bp.down;
exports.between = bp.between;
exports.only = bp.only;
